export const GET_CHEMICAL_PRODUCT_HISTORY = 'GET_CHEMICAL_PRODUCT_HISTORY';
export const GET_CHEMICAL_PRODUCT_HISTORY_SUCCESS = `${GET_CHEMICAL_PRODUCT_HISTORY}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_HISTORY_FAILURE = `${GET_CHEMICAL_PRODUCT_HISTORY}/FAILURE`;

export const GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA =
  'GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA';
export const GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_SUCCESS = `${GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_FAILURE = `${GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA}/FAILURE`;

export default {
  GET_CHEMICAL_PRODUCT_HISTORY,
  GET_CHEMICAL_PRODUCT_HISTORY_SUCCESS,
  GET_CHEMICAL_PRODUCT_HISTORY_FAILURE,
  GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA,
  GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_SUCCESS,
  GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_FAILURE
};
